// extracted by mini-css-extract-plugin
export default {"container":"TextOnly_container_laUox","text":"TextOnly_text_CxGx9","title":"TextOnly_title_VLOyq"};